import React, { useState } from 'react';
import './About.css'; // Using About.css for modal styling

const ProductModal = ({ product, onClose }) => {
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleImageClick = (imgSrc) => {
    setEnlargedImage(imgSrc);
  };

  const handleCloseEnlargedImage = () => {
    setEnlargedImage(null);
  };

  if (!product) {
    return null;
  }

  // Destructure product with default values
  const {
    name = 'No Title',
    description = 'No description available.',
    mainImage: rawMainImage = '/default-image.png', // Default image path if none provided
    additionalImages: rawAdditionalImages = [], // Default to empty array
    specifications: rawSpecifications = [], // Default to empty array
  } = product;

  // Prefix main image URL
  const prefixedMainImage = rawMainImage.startsWith('http')
    ? rawMainImage
    : `https://apiqms.shigjeta.com${rawMainImage}`;

  // Prefix additional image URLs. Assuming rawAdditionalImages is an array of strings.
  // If it's an array of objects like [{ src: 'path', alt: 'desc' }], you'd adjust this.
    const prefixedAdditionalImages = rawAdditionalImages.map((imgItem) => ({ // Renamed to imgItem to avoid confusion
    src: imgItem.src && !imgItem.src.startsWith('http') ? `https://apiqms.shigjeta.com${imgItem.src}` : imgItem.src,
    alt: imgItem.alt || name || 'Additional Image', // Ensure alt text is also handled
  }));

  // Handle description: if it's plain text, we'll split it. If it's HTML, we'll use dangerouslySetInnerHTML.
  // For now, let's assume it's plain text as per your original component and split it.
  // If you expect HTML, you can use dangerouslySetInnerHTML for `description` as well.
  const descriptionLines = description.split("\n");


  return (
    <>
      {/* Modal Overlay */}
      <div className="modal-overlay show" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-btn" onClick={onClose}>
            &times;
          </button>

          {/* Product Images */}
          <div className="modal-images">
            <img
              src={prefixedMainImage}
              alt={name}
              className="main-image"
              onClick={() => handleImageClick(prefixedMainImage)}
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop if default image also fails
                e.target.src = 'https://apiqms.shigjeta.com/default-image.png'; // Fallback default image
                console.error(`Modal: Failed to load main image for ${name}: ${rawMainImage}`);
              }}
            />

            {prefixedAdditionalImages.length > 0 && (
              <div className="additional-images">
                {prefixedAdditionalImages.map((imageObject, index) => (
                  <img
                    key={index}
                    src={imageObject.src}
                    alt={imageObject.alt}
                    onClick={() => handleImageClick(imageObject.src)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://apiqms.shigjeta.com/default-image.png';
                      console.error(`Modal: Failed to load additional image ${index + 1} for ${name}: ${imageObject.src}`);
                    }}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Product Info Container */}
          <div className="modal-info">
            {/* Product Title */}
            <div className="modal-header">
              <h2>{name}</h2>
            </div>

            {/* Product Description */}
             <div className="modal-description">
              {/* Check if description has content (excluding just empty <p> tags) */}
              {description && description.trim() !== '<p></p>' ? (
                <div dangerouslySetInnerHTML={{ __html: description }} />
              ) : (
                <p>No description available.</p>
              )}
            </div>

            {/* Specifications Section */}
           {rawSpecifications.length > 0 && (
              <div className="modal-specifications">
                <h3>Specifications:</h3>
                <ul>
                  {rawSpecifications.map((spec, index) => (
                    <li key={index}>{spec}</li>
                  ))}
                </ul>
              </div>
            )}
            {rawSpecifications.length === 0 && (
                <p>No specifications listed.</p>
            )}
          </div>
        </div>
      </div>

      {/* Enlarged Image View */}
      {enlargedImage && (
        <div className="enlarged-image-container">
          <div className="enlarged-image-content">
            <img src={enlargedImage} alt="Enlarged View" className="enlarged-image" />
            <button className="enlarged-image-close-btn" onClick={handleCloseEnlargedImage}>
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductModal;